export default "__VITE_ASSET__vZmOPmu0__"